import { createContext } from "react";

/**
 * What a template's text slots need from the page drawing it:
 *   texts        slot → the line to show (slots.js `slotTexts`)
 *   editable     the editor's preview lets the couple type on the lines
 *   onTextInput  (slot, value) — they typed in one
 *
 * Null outside a template: a slot then shows the template's own line.
 */
export const SlotContext = createContext(null);
